<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto pt-[3.75vw] pb-[2vw] bg-white">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          赛事集锦
        </div>
      </div>
    </div>

    <!-- 图片区域上 -->
    <div
      class="relative w-[61.46vw] h-[32.03vw] left-1/2 -translate-x-1/2 inline-flex justify-between items-between animation-trigger"
    >
      <!-- 竖版图片区域1 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[21.2vw]"
          src="@/assets/images/Competition/module3/p1_list1_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list1_image2.png"
        />
      </div>
      <!-- 横版图片区域1 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list2_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list2_image2.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list2_image3.png"
        />
      </div>
      <!-- 横版图片区域2 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list3_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list3_image2.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list3_image3.png"
        />
      </div>
      <!-- 竖版图片区域2 -->
      <div
        class="w-[15vw] h-full inline-flex flex-col justify-between items-center flex-shrink-0 image-container"
      >
        <img
          class="self-stretch h-[21.2vw]"
          src="@/assets/images/Competition/module3/p1_list4_image1.png"
        />
        <img
          class="self-stretch h-[10.36vw]"
          src="@/assets/images/Competition/module3/p1_list4_image2.png"
        />
      </div>
    </div>
    <!-- 图片区域下 -->
<!--    <div
      class="relative w-[61.46vw] h-auto mt-[3.33vw] gap-[2vw] left-1/2 -translate-x-1/2 flex-col inline-flex items-between overflow-hidden"
    >
      &lt;!&ndash; 标题区域 &ndash;&gt;
      <div class="w-full h-auto mx-auto flex flex-col justify-center">
        &lt;!&ndash; 主标题框 &ndash;&gt;
        <div class="h-auto flex flex-col justify-center items-center">
          <div
            class="text-[2.71vw] text-[#1A2233] font-harmony font-bold text-center"
          >
            学生获奖证书
          </div>
        </div>
      </div>
      &lt;!&ndash; 竖版图片区域1-380.4vw &ndash;&gt;
      <div class="relative overflow-hidden h-[16vw]">
        <div
          class="flex gap-[0.98vw] animate-scroll-right_row1 flex-nowrap"
          :style="{ minWidth: `${(11.7 + 0.98) * row1Images.length * 2}vw` }"
        >
          &lt;!&ndash; 移除动画和溢出隐藏 &ndash;&gt;
          <template v-for="i in 2">
            <el-image
              v-for="(src, index) in row1Images"
              :key="`row1-${index}-${i}`"
              class="w-[11.7vw] h-[16vw] object-cover flex-shrink-0 border"
              :src="src"
              lazy
              alt="图片"
            />
          </template>
        </div>
      </div>
      &lt;!&ndash; 横版图片区域1-701.36vw &ndash;&gt;
      <div class="relative overflow-hidden h-[10.36vw]">
        <div
          class="flex gap-[0.98vw] animate-scroll-right_row2 flex-nowrap"
          :style="{ minWidth: `${(14.96 + 0.98) * row2Images.length * 2}vw` }"
        >
          <template v-for="i in 2">
            <el-image
              v-for="(src, index) in row2Images"
              :key="`row2-${index}-${i}`"
              class="w-[14.96vw] h-[10.36vw] object-cover flex-shrink-0 border"
              :src="src"
              lazy
              alt="图片"
            />
          </template>
        </div>
      </div>
    </div>-->


  </div>
</template>

<script>
export default {
  name: "competition-module3",
  data() {
    return {
      animated: false,
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true;
            // 为每个图片添加随机动画延迟
            document.querySelectorAll(".image-container img").forEach((img) => {
              img.style.setProperty("--delay", `${Math.random() * 0.8}s`);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.$el.querySelector(".animation-trigger"));
  },
  computed: {
    row1Images() {
      const context = require.context(
        "@/assets/images/Competition/module3/",
        false,
        /p1_row1_image\d{2}\.jpg$/
      );
      return context.keys().map((key) => context(key));
    },
    row2Images() {
      const context = require.context(
        "@/assets/images/Competition/module3/",
        false,
        /p1_row2_image\d{2}\.jpg$/
      );
      return context.keys().map((key) => context(key));
    },
  },
};
</script>

<style scoped>
/* 淡入动画 */
.image-container img {
  opacity: 0;
  animation: fadeIn 1s ease-out var(--delay) forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(1.04vw);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 滚动动画 */
@keyframes scroll-right_row1 {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

@keyframes scroll-right_row2 {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.scroll-container {
  will-change: transform;
  transform: translateZ(0); /* 启用GPU加速 */
}

/* 滚动容器速度7 */
.animate-scroll-right_row1 {
  animation: scroll-right_row1 54.343s linear infinite;
}
.animate-scroll-right_row2 {
  animation: scroll-right_row2 100.194s linear infinite;
}

/* 添加布局修正 */
.flex-scroll-container {
  display: flex;
  width: max-content; /* 关键：避免父容器宽度限制 */
}

/* 在原有样式基础上添加 */
.bg-gradient-to-r {
  background-image: linear-gradient(
    to right,
    #f5f5f7 30%,
    rgba(245, 245, 247, 0.6) 70%,
    rgba(245, 245, 247, 0)
  );
}

.bg-gradient-to-l {
  background-image: linear-gradient(
    to left,
    #f5f5f7 30%,
    rgba(245, 245, 247, 0.6) 70%,
    rgba(245, 245, 247, 0)
  );
}
</style>
